<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style scoped>
.custom-head-wrap {
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #dfdfdf;
}
</style>
<template>
  <div id="user-edit-tab-info">
    <div class="tab-top-part">
      <!-- Avatar Row -->
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mb-5">
          <!-- <h3>Session Type - {{session_data.SessionTypeDetails.TypeName}}</h3> -->
          <div class="custom-head-wrap">
            <!-- <h2 class="cms-custom-heading">Session Type - {{sessionType.label}}</h2>
                <p class="mt-1 mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p> -->

            <input
              type="text"
              v-click-outside="hideFullName"
              @click="toggleFullName"
              name="FirstName"
              v-show="showHideFullName"
              id="FirstName"
              placeholder="First Name*"
              v-model="data_local.FirstName"
            />

            <input
              type="text"
              v-click-outside="hideFullName"
              @click="toggleFullName"
              name="LastName"
              v-show="showHideFullName"
              id="LastName"
              placeholder="Last Name*"
              v-validate="'required'"
              v-model="data_local.LastName"
            />

            <input
              type="text"
              v-show="!showHideFullName"
              @click="toggleFullName"
              name="FullName"
              class="w-full full-name-box"
              id="FullName"
              placeholder="Speaker Name*"
              v-model="data_local.Name"
              readonly
            />
          </div>
          <span class="text-danger text-sm" v-show="errors.has('LastName')"
            >The Name field is required</span
          >
        </div>
        <div class="vx-col md:w-6/12 w-full">
          <div class="border-1 image-wrap-area">
            <div class="flex items-center flex-col sm:flex-row">
              <img :src="imgSrc" class="mr-8 rounded h-24 w-24" />
              <div>
                <p class="text-lg font-medium mb-2 mt-4 sm:mt-0"></p>
                <input
                  id="uploadFile"
                  type="file"
                  class="hidden"
                  ref="update_avatar_input"
                  @change="update_avatar"
                  accept="image/*"
                />
                <vs-button @click="$refs.update_avatar_input.click()"
                  >Upload</vs-button
                >

                <!--<vs-button type="border" color="danger">Remove Avatar</vs-button>-->
              </div>
            </div>
            <p class="mt-2 rco-size">High quality image: 200x200px (1:1 ratio)</p>
          </div>
        </div>
        <div class="vx-col md:w-3/12 w-full mt-4">
          <label>Add as an Attendee (email mandatory)</label>
          <vs-switch
            class="vx-col sm:w-1/12 w-full"
            v-model="data_local.IsAttendee"
            :disabled="this.$route.params.SpeakerId"
          />
        </div>
        <div class="vx-col md:w-3/12 w-full mt-4">
          <label
            >Email <span class="rqrd" v-if="data_local.IsAttendee">*</span></label
          >
          <vs-input
            class="inputx w-full"
            name="Email"
            v-model="data_local.Email"
            v-validate="data_local.IsAttendee ? 'required|email' : 'email'"
            :readonly="emailFieldReadOnly"
          />
          <span class="text-danger text-sm" v-show="errors.has('Email')">{{
            errors.first("Email")
          }}</span>
        </div>
      </div>
      <!-- Content Row -->
      <div class="vx-row">
        <!-- <div class="vx-col md:w-1/2 w-full mt-4">
          <label>
            First Name
            <span class="rqrd">*</span>
          </label>
          <vs-input
            class="inputx w-full"
            name="First Name"
            v-model="data_local.FirstName"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('First Name')"
          >{{ errors.first('First Name') }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>
            Last Name
            <span class="rqrd">*</span>
          </label>
          <vs-input
            class="inputx w-full"
            name="Last Name"
            v-model="data_local.LastName"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Last Name')"
          >{{ errors.first('Last Name') }}</span>
        </div> -->

        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Company</label>
          <vs-input
            class="inputx w-full"
            name="Company"
            v-model="data_local.Company"
          />
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Job Title</label>
          <vs-input
            class="inputx w-full"
            name="Designation"
            v-model="data_local.Designation"
          />
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Phone Number</label>
          <vs-input
            class="inputx w-full"
            name="Phone"
            v-model="data_local.Phone"
          />
          <span class="text-danger text-sm" v-show="errors.has('Phone')">{{
            errors.first("Phone")
          }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4 hidden">
          <label>Group</label>
          <vs-input
            class="inputx w-full"
            name="Group"
            v-model="data_local.Group"
          />
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Website</label>
          <vs-input
            class="inputx w-full"
            name="Website"
            v-validate="'url:require_protocol'"
            v-model="data_local.Website"
          />
          <span class="text-danger text-sm" v-show="errors.has('Website')">{{
            errors.first("Website")
          }}</span>
        </div>
        <div class="vx-col md:w-1/1 w-full mt-4">
          <label>Short Bio</label>
          <!-- <quill-editor class="inputx w-full" name="Profile" v-model="data_local.Profile" ></quill-editor> -->
          <ckeditor
            class="desc-event"
            v-model="data_local.Profile"
            :config="editorConfig"
          ></ckeditor>
        </div>
        <!--<div class="vx-col md:w-1/1 w-full mt-2">
          <label>Resources </label>
          <div class="vx-col md:w-1/1 w-full mt-2" v-for="file in data_local.Resources">
          <a :href="file">File</a>
          </div>

        <input type="file" multiple class="hidden" ref="update_resource_input" @change="upload_resources" accept=".csv.excel,.xlsx,.pdf,.doc,.docx">
              <vs-button class="mr-4 mb-4" @click="$refs.update_resource_input.click()">Upload Resources</vs-button>
        </div>-->
      </div>
    </div>
    <div class="tab-botttom-sticky-part">
    <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="mt-2" @click="$router.push('/event/speakers')"
              >Back To List</vs-button
            >
            <vs-button
              class="ml-auto mt-2"
              @click="before_save(true)"
              :disabled="!validateForm"
              color="success"
              >Save & Continue</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              @click="before_save(false)"
              :disabled="!validateForm"
              color="success"
              >Save & Exit</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              type="border"
              color="warning"
              @click="reset_data"
              >Reset</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      fullscreen="fullscreen"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
import ClickOutside from "vue-click-outside";

export default {
  components: {
    vSelect,
    quillEditor,
    "v-select": vSelect,
    ckeditor: CKEditor.component,
    PhotowallResizeComponent,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      imgSrc:
        this.data.ProfilePictureURL == "" ||
        this.data.ProfilePictureURL == undefined
          ? require("@/assets/images/default_avatar.jpg")
          : this.data.ProfilePictureURL,
      ResourceFiles: [],
      emailFieldReadOnly: false,
      editorConfig: CKconfig.editorConfig,
      imageRatio: 1 / 1,
      cropImageUrl: null,
      resetCropper: 0,
      displayImageRatio: "1:1",
      popupCropper: false,
      showHideFullName: false,
    };
  },
  computed: {
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status,
        };
      },
      set(obj) {
        this.data_local.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role,
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    toggleFullName() {
      if (this.data_local.FirstName == "" && this.data_local.LastName == "") {
        this.data_local.Name = "";
      } else {
        this.data_local.Name =
          this.data_local.FirstName + " " + this.data_local.LastName;
      }

      this.showHideFullName = true;
      //  setTimeout(() => {
      //   document.getElementById("FirstName").focus();
      // }, 300);
    },
    hideFullName() {
      if (this.data_local.FirstName == "" && this.data_local.LastName == "") {
        this.data_local.Name = "";
      } else {
        this.data_local.Name =
          this.data_local.FirstName + " " + this.data_local.LastName;
      }
      this.showHideFullName = false;
      setTimeout(() => {
        document.getElementById("FirstName").focus();
      }, 300);

    },
    croppedImagePath(blob) {
      this.imgSrc = blob;
      this.popupCropper = false;
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    before_save(form_continue = false) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes(form_continue);
        }
      });
    },
    upload_resources(input) {
      if (input.target.files.length) {
        for (var i = 0; i < input.target.files.length; i++) {
          const file = input.target.files[i];
          const metadata = {
            contentType: file.type,
          };
          //console.log(file)
          let filename = file.name;
          filename = filename.split(".").pop();
          //console.log(filename)
          const validImageTypes = [
            "csv",
            "pdf",
            "xlsx",
            "excel",
            "doc",
            "docx",
          ];
          if (!validImageTypes.includes(filename)) {
            alert("Only files allowed.");
            return false;
          }
          this.data_local.Resources.push(file.webkitRelativePath);
          this.ResourceFiles.push(file);
        }
      }
    },
    save_changes(form_continue = false) {
      /* eslint-disable */
      if (!this.validateForm) return;

      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      this.$vs.loading();
      /* eslint-enable */
      this.data_local.ProfilePictureURL = this.imgSrc;
      this.data_local.ResourceFiles = this.ResourceFiles;
      this.ResourceFiles = [];
      const Id = this.$route.params.SpeakerId;
      if (Id) {
        this.$store
          .dispatch("speakerManagement/updateSpeaker", {
            id: Id,
            data: this.data_local,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Speaker",
                text: "Speaker updated successfully.",
              });
              if (form_continue) this.$emit("activateTab", 1);
              else this.$router.push("/event/speakers/");
            } else {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "Speaker",
                text: res.message,
              });
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Speaker",
              text: "Something went wrong!",
            });
          });
      } else {
        this.$store
          .dispatch("speakerManagement/addSpeaker", { data: this.data_local })
          .then((res) => {
            //alert(res.message)
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Speaker",
                text: "Speaker created successfully.",
              });
              if (form_continue) {
                this.$router.push({
                  name: "speaker-edit",
                  params: {
                    SpeakerId: res.Id,
                  },
                });
              } else this.$router.push("/event/speakers");
            } else if (res.status == 500) {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "Speaker",
                text: res.message,
              });
            } else {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Speaker",
                text: res.message,
              });
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Speaker",
              text: "Something went wrong!",
            });
          });
      }
    },
    reset_data() {
      document.getElementById("uploadFile").value = "";
      this.data_local = JSON.parse(JSON.stringify(this.data));
      this.imgSrc =
        this.data.ProfilePictureURL == "" ||
        this.data.ProfilePictureURL == undefined
          ? require("@/assets/images/default_avatar.jpg")
          : this.data.ProfilePictureURL;
    },
    update_avatar(input) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        this.data_local.file = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.resetCropper += 1;
          this.cropImageUrl = null;
          this.cropImageUrl = e.target.result;
          this.popupCropper = true;
          //this.imgSrc = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
  mounted() {
    this.popupItem = this.$el;
    if (
      this.$route.params.SpeakerId != undefined ||
      this.$route.params.SpeakerId != null
    ) {
      this.emailFieldReadOnly = true;
    }
  },
};
</script>
